import { OTP } from "../Reducers/otpReducer";
import {addNewPartner, createOtp, createPartnerV2, verifyOtp} from "../Util/queries";
import verifyEmailAndPass from "./loginAction";

export const SIGN_UP_STATE = "SIGN_UP_STATE";

const newUserSignUp = (companyName, phoneNumber, emailAddress,
                       address, contactPerson,
                       contactPersonTitle, billingAddress,
                       password, countryCode) => async dispatch => {
    try {
        let response = await addNewPartner({
            companyName: companyName, address: address,
            phoneNumber: phoneNumber, email: emailAddress, contactPerson: contactPerson,
            titleOfContactPerson: contactPersonTitle, billingAddress: billingAddress,
            partnerType: "AFFILIATE", password: password, countryCode: countryCode
        })

        if (response.status === 200 || response.status === 201) {
            dispatch(verifyEmailAndPass(emailAddress, password))
        } else {
            dispatch({
                type: SIGN_UP_STATE,
                payload: false
            })
        }
    } catch (e) {
        dispatch({
            type: SIGN_UP_STATE,
            payload: false
        })
    }
}

const fixPhone = (phone) => {
    if (phone?.[0] === '+') return phone;
    else return '+' + phone;
}

const OTP_RE_REQUEST_TIME = 5 * 60 * 1000;

export const generateOtp = (phoneNumber, countryCode) => async (dispatch, getState) => {
    const currentState = getState();
    const otpInfo = currentState.otp;
    
    if (otpInfo.phoneNumber === phoneNumber && 
        otpInfo.generated === true && 
        otpInfo.requestTime && 
        (Date.now() - otpInfo.requestTime) < OTP_RE_REQUEST_TIME) {
        return;
    }

    dispatch({
        type: OTP,
        payload: {phoneNumber: phoneNumber, generated: null, verified: false, genError: false, verifError: false, requestTime: Date.now()}
    })
    try {
        let response = await createOtp({phoneNumber: fixPhone(phoneNumber), countryCode: countryCode});
        dispatch({
            type: OTP,
            payload: {
                phoneNumber: phoneNumber, 
                generated: response.data.success, 
                attemptsLeft: response.data.remainingAttempts, 
                verified: null, 
                genError: false, 
                verifError: false, 
                requestTime: Date.now(),
                medium: response.data.medium // SMS or WHATSAPP
            }
        })

    } catch (e) {
        dispatch({
            type: OTP,
            payload: {phoneNumber: phoneNumber, generated: null, genError: true, requestTime: null, medium: null}
        })
    }
}

export const verifyOtpAndCreatePartner = (data, otp) => async dispatch => {
    const payload = {
        contactPerson: data.firstName + " " + data.lastName,
        email: data.email,
        phoneNumber: fixPhone(data.phoneNumber),
        countryCode: data.country,
        password: data.password,
        otp: otp,
    }
    dispatch({
        type: OTP,
        payload: {phoneNumber: data.phoneNumber, verified: null, genError: false, verifError: false}
    })
    try {
        let response = await verifyOtp({phoneNumber: payload.phoneNumber, otp: otp});
        if (response.data.success) {
            dispatch({
                type: OTP,
                payload: {phoneNumber: data.phoneNumber, verified: true, attemptsLeft: 0, genError: false, verifError: false}
            });
        } else {
            dispatch({
                type: OTP,
                payload: {phoneNumber: data.phoneNumber, verified: false, attemptsLeft: response.data.remainingAttempts, genError: false, 
                    verifError: response.data.remainingAttempts === 0}
            });
            return;
        }
    } catch (e) {
        dispatch({
            type: OTP,
            payload: {phoneNumber: data.phoneNumber, verified: false, verifError: true}
        })
        return;
    }
    
    dispatch({
        type: SIGN_UP_STATE,
        payload: null
    })
    try {
        let response = await createPartnerV2(payload)

        if (response.status === 200 || response.status === 201) {
            dispatch(verifyEmailAndPass(payload.email, payload.password))
        } else {
            dispatch({
                type: SIGN_UP_STATE,
                payload: false
            })
        }
    } catch (e) {
        dispatch({
            type: SIGN_UP_STATE,
            payload: false
        })
    }
}

export default newUserSignUp;
